<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd" @ClickOnClearButton="ClickOnClearButton"/>

    <basic-table
      v-if="cardPools"
      :items="cardPools"
      :fields="cardPoolsFields"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <FormAdd :selectedCardPools="selectedCardPools" v-if="!curCardPools"/>
    <FormListCard :editItem="curCardPools"/>
  </div>
</template>

<script>
import FormAdd from './formAdd'
import FormListCard from './formListCard'

export default {
  components: {
    FormAdd,
    FormListCard
  },
  data () {
    return {
      cardPoolsFields: [
        {key: 'pool_id', label: 'ID', sortable: true},
        {key: 'cards', label: this.$i18n.t('Cards count'), sortable: true},
        {key: 'cards_used', label: this.$i18n.t('Cards activated'), sortable: true},
        {key: 'first_update', label: this.$i18n.t('Created'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'last_update', label: this.$i18n.t('Updated'), sortable: true, formatter: (val, key, item) => { return val ? this.$root.showDataWithTZDelta(val) : this.$i18n.t('Not installed') }},
        {key: 'actions', label: this.$i18n.t('Actions')}
      ],
      selectedCardPools: null,
      curCardPools: null,
      options: {
        isShowAddButton: true,
        isShowClearButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.curCardPools = null
      this.selectedCardPools = {
        pool_id: 0,
        size: 100,
        balance: '',
        sec_size: 8,
        currency: this.$store.getters['Settings/REGISTRY_SETTINGS_SYS_CURRENCY'],
        delay: 100,
        days: 0,
        service_id: 0,
        random: 0,
        expire: 0
      }
      this.$root.$emit('bv::show::modal', 'modalFormAddCardPools', '#btnShow')
    },
    async editItem (item) {
      await this.$store.dispatch('Users/GET_CARD_POOL', item.pool_id).then(response => {
        this.curCardPools = this.$store.getters['Users/CARD_POOL']
        this.curCardPools.pool_id = item.pool_id
      })
      this.$root.$emit('bv::show::modal', 'modalFormListCardPools', '#btnShow')
    },
    ClickOnClearButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', 'Are you sure you want to clear expired cards', this.deleteItem, item)
    },
    deleteItem (item) {
      this.$store.dispatch('Users/CLEAR_EXPIRED_CARD_POOL')
      this.$store.dispatch('Users/GET_CARD_POOLS')
      this.$root.$emit('makeToasts')
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    cardPools () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Users/CARD_POOLS']))
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_REGISTRY_SETTINGS_SYSTEM_CURRENCY')
    this.$store.dispatch('Users/GET_CARD_POOLS')
    this.$store.dispatch('ReferenceBooks/GET_CURRENCIES')
    this.$store.dispatch('Users/GET_SYSTEM_USERS_SHORT_DATA')
    this.$store.dispatch('Tariffing/GET_TARIFFS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/cardPools/main.vue